import { useNavigate } from "react-router-dom";
import CheckIcon from "../../../../../assets/images/check_icon.svg?react";
import ThemeConstants from "../../../../../config/theme/theme_constants";
import { useTranslation } from "../../../../../i18n/useTranslation";

interface ItemResourceProps {
  id: string;
  title: string;
  pictureUrl?: string;
  viewed?: boolean;
}

const ResourceItem: React.FC<ItemResourceProps> = ({ id, title, pictureUrl, viewed = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = ThemeConstants();

  return (
    <div
      className="min-w-32.5 max-w-32.5 flex flex-col gap-1.25 cursor-pointer h-full justify-between"
      onClick={() => navigate(`/career/resource/${id}`)}
    >
      <div className="relative">
        {pictureUrl ? (
          <img
            src={pictureUrl}
            alt={title}
            className={`w-full aspect-square object-cover rounded-[30px] transition-[filter,opacity] duration-200 ${viewed ? "grayscale-30 opacity-90" : ""}`}
          />
        ) : (
          <div className="w-full aspect-square bg-gray-300 rounded-[30px]" />
        )}
        {viewed && (
          <div
            className="absolute top-3 right-3 w-5 h-5 rounded-full flex items-center justify-center shadow ring-1 ring-white/80"
            style={{ background: theme.UvibesPink }}
            aria-label={t('course.resource.viewed')}
          >
            <CheckIcon className="w-3 h-3" />
          </div>
        )}
      </div>
      <p className={`text-xs font-medium leading-none line-clamp-2 max-w-30 ${viewed ? "opacity-70" : ""}`}>
        {title}
      </p>
    </div>
  );
};

export default ResourceItem;
